export class FilterResponseModel {
  selectedFieldName: string;
  selectedCondition: string;
  selectedValue: string[];
}
